export default __webpack_public_path__ + "locales/si/CreateEditRoomDialog.json?hash=200512487bf0acfc40f1a0a7d7176eef";